export const HEADER_HEIGHT = '56px';
export const MOBILE_CONFIRM_MODAL_WIDTH = '432px';
